<span
  class="vl-tooltip"
  [attr.data-tooltip]="text"
  [ngClass]="'vl-tooltip' + (position ? '--' + position : '')"
  >i</span
>
